const exclusionPrefixPattern = /^[\s"'([{]*[-‐‑‒–—−]+\s*/

const normalizePromptPart = (value: string): string =>
  value
    .trim()
    .replace(/^[\s"'([{]+/, '')
    .replace(/[\s"',.;:)\]}]+$/, '')
    .replace(/\s+/g, ' ')

const normalizeExcludedStyle = (value: string): string =>
  normalizePromptPart(value).replace(/^(?:as\s+)?(?:a|an|the)\s+/i, '')

const parsePromptParts = (stylePrompt: string): {
  excludedStyles: string[]
  positiveParts: string[]
} => {
  const positiveParts: string[] = []
  const excludedStyles: string[] = []
  const parts = stylePrompt
    .split(/[,\n]+/)
    .map(normalizePromptPart)
    .filter(Boolean)

  for (const part of parts) {
    if (exclusionPrefixPattern.test(part)) {
      const excludedStyle = normalizeExcludedStyle(part.replace(exclusionPrefixPattern, ''))

      if (excludedStyle) {
        excludedStyles.push(excludedStyle)
      }

      continue
    }

    positiveParts.push(part)
  }

  return { excludedStyles, positiveParts }
}

export const splitStylePrompt = (input: string): {
  excludePrompt: string
  stylePrompt: string
} => {
  if (!input.trim()) {
    return { excludePrompt: '', stylePrompt: '' }
  }

  const { excludedStyles, positiveParts } = parsePromptParts(input)

  return {
    excludePrompt: excludedStyles.join(', '),
    stylePrompt: positiveParts.join(', ') || input.trim()
  }
}
